// MF-526 — Single source of truth for the student-summary visual tokens. Kept in one place so a
// dark theme (or a brand re-skin) is a swap here, not a hunt across components. Maestro is light
// today; these are the approved (artifact-signed-off) values.
export const SUMMARY_PALETTE = {
  good: '#3a6ea5', // positive change / primary tone (attendance, GPA, points)
  bad: '#e08a3c', // caution tone (lates) / negative change
  ink: '#24303f',
  muted: '#667487',
  faint: '#98a3b3',
  grid: '#eef2f7',
  surface: '#ffffff',
  cardBorder: '#e7edf4'
}

// A metric "tone" maps to one accent colour (big number + chart marks).
export const toneColor = (tone) => (tone === 'bad' ? SUMMARY_PALETTE.bad : SUMMARY_PALETTE.good)

// A delta is coloured by whether the change is GOOD (not by its direction): fewer lates is good,
// fewer behaviour points is concerning.
export const deltaColor = (good) => (good ? SUMMARY_PALETTE.good : SUMMARY_PALETTE.bad)

export default SUMMARY_PALETTE
